/* AIRVEX · Scroll-Zoom
   Große Stimmungs- und Raumbilder werden beim Scrollen sanft größer ("in") oder kleiner ("out").
   Aktiviert über den Abschnitt „AIRVEX · SCENT-Stil“ (Einstellung Scroll-Zoom).
   Nutzt die CSS-Eigenschaft "scale" – bestehende Hover- und Einblend-Effekte (transform) bleiben erhalten.
   Bei „Bewegung reduzieren“ im System ist der Effekt aus. */
(function () {
  if (window.__axZoomLoaded) return;
  window.__axZoomLoaded = true;
  if (!window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var cfg = window.axZoomCfg || {};
  var AMT = Number(cfg.amt) || 0.1;

  /* Welche Bilder zoomen: [Selektor, Richtung, Ausschluss] */
  var MAP = [
    ['.axh__media .axh__img', 'out', '.axh__step'],   /* Hero oben (Landingpage), nicht die Anleitungs-Schritte */
    ['.axr__img', 'in'],                              /* Räume mit Charakter */
    ['.axc__img', 'in'],                              /* Schlussbild Landingpage */
    ['.vmo__img', 'in'],                              /* VELUN Stimmungsband */
    ['.vst__img', 'in'],                              /* VELUN Duftgeschichte */
    ['.vov__panel-img', 'in'],                        /* Übersicht: Duftwelt-Bild */
    ['.vov__set-img', 'in'],                          /* Übersicht: Set-Kachel */
    ['.vdf__intro-img', 'out'],                       /* Duft-Finder: Startbild */
    ['.vft__img', 'in']                               /* Finder-Kachel */
  ];

  var active = [];
  var ticking = false;

  function box(img) {
    var el = img.parentElement;
    while (el && el !== document.body && getComputedStyle(el).display === 'contents') el = el.parentElement;
    return el || img;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var i = active.indexOf(e.target);
      if (e.isIntersecting && i === -1) active.push(e.target);
      if (!e.isIntersecting && i !== -1) active.splice(i, 1);
    });
    request();
  }, { rootMargin: '15% 0px 15% 0px' });

  function collect(scope) {
    MAP.forEach(function (m) {
      (scope || document).querySelectorAll(m[0]).forEach(function (img) {
        if (img.__axz || (m[2] && img.closest(m[2]))) return;
        img.__axz = { dir: m[1], box: box(img) };
        img.style.willChange = 'scale';
        io.observe(img);
      });
    });
  }

  function update() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var k = 0; k < active.length; k++) {
      var img = active[k];
      var z = img.__axz;
      var r = z.box.getBoundingClientRect();
      if (!r.height) continue;
      var p = (vh - r.top) / (vh + r.height);
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      var s = z.dir === 'out' ? 1 + AMT * (1 - p) : 1 + AMT * p;
      img.style.scale = s.toFixed(4);
    }
  }

  function request() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }

  function start() {
    collect(document);
    request();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });
    document.addEventListener('shopify:section:load', function (e) { collect(e.target); request(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
